import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  theme => ({
    mainContent: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      flexGrow: 1,
      paddingBottom: 30,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(2),
    },
    installNotice: {
      alignText: "center",
      paddingTop: 100,
      paddingBottom: 20,
    },
    loadingBackdrop: {
      backgroundColor: "transparent",
      zIndex: theme.zIndex.modal + 100,
    },
    notificationUI: {
      top: 120,
      [theme.breakpoints.up("xs")]: {
        top: 60,
      },
    },
  }),
  {
    classNamePrefix: "MainLayout",
  },
);
